import { writable } from "svelte/store"
import { browser } from "$app/environment"

type Theme = "light" | "dark"

export const userTheme = browser && localStorage.getItem("color-scheme")

// create theme store
export const theme = writable(userTheme || "dark")

// update theme
export function toggleTheme() {
  theme.update((currentTheme) => {
    const newTheme = currentTheme === "dark" ? "light" : "dark"

    document.documentElement.setAttribute("color-scheme", newTheme)
    document.documentElement.setAttribute("class", newTheme)

    localStorage.setItem("color-scheme", newTheme)

    return newTheme
  })
}

// Set the Theme
export function setTheme(newTheme: Theme) {
  theme.set(newTheme)
}
